module.exports = __webpack_public_path__ + "img/button_presnaZhoda_on.9dd04560.svg";